import { registerComponent } from '../app'
import { CART_UPDATED } from '../events'

const CartCount = (scope, el) => {
	const props = {
		animateClass: 'animate',
		largeClass: 'large'
	}

	scope.on(CART_UPDATED, data => {
		el.textContent = data.item_count
		data.item_count > 9
			? el.classList.add(props.largeClass)
			: el.classList.remove(props.largeClass)
		if (data.item_count) {
			window.requestAnimationFrame(() => {
				el.classList.add(props.animateClass)
				setTimeout(() => {
					el.classList.remove(props.animateClass)
				}, 500)
			})
		}
	})
}

registerComponent('cart-count', CartCount)
